import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackInCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 18,
		cy: 18,
		r: 17,
		stroke: "#CCCCCC",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 14L16 18L20 22",
		stroke: "#CCCCCC",
		strokeWidth: 2
	})]
});
export default SvgBackInCircleIcon;
